module.exports = new Promise(resolve => {
            const script = document.createElement('script');
            script.src = window.location.origin + '/mfe/tcm/remoteEntry.js';
            script.onload = () => { resolve(window['tcm']); };
            script.onerror = () => { resolve({ get: () => Promise.resolve(() => () => 'Module tcm unavailable'), init: () => {} }); };
            document.head.appendChild(script);
        });